import { render, staticRenderFns } from "./problem-record.vue?vue&type=template&id=66ea6c3d&scoped=true"
import script from "./problem-record.vue?vue&type=script&lang=js"
export * from "./problem-record.vue?vue&type=script&lang=js"
import style0 from "./problem-record.vue?vue&type=style&index=0&id=66ea6c3d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ea6c3d",
  null
  
)

export default component.exports